<template>
<div class="ui segment contents" style="width: 1000px;">
  <div v-if="form.hasErrors()" class="ui warning message">入力エラー</div>
  <form class="ui form" :class="{'loading': form.waiting, 'warning': form.hasErrors()}">
    <div class="field">
      <button type="button" class="ui positive button" @click="save()" :class="{'loading': form.waiting}">保存する</button>
    </div>
    <basic-shop :form="form" is-new></basic-shop>
  </form>
</div>
</template>

<script>
import BasicShop from './edit/basicShop.vue';

export default {
    components: {
        BasicShop: BasicShop,
    },
    data: function() {
        return {
            form: this.createForm({
            is_public: false,
            rank: 'D',
            shop_type: 1,
            charge_rate: 0,
            is_recommended: false,
            can_reserve: false,
            lunch_ok: false,
            bringing_ok: false,
            billing_subject: '税込総額',
            is_promotion: false,
            area: '',
            area_detail: '',
            faq_required: true,
            }),
        };
    },
    mounted: function() {
        $('.ui.checkbox').checkbox();
    },
    methods: {
        save: function() {
            this.form.post('/afadmin/api/shops', function(response) {
                window.location.href = response.data.edit_url;
            });
        }
    }
};
</script>
